// Pack-size switcher for product cards.
//
// data-price / data-compare (rendered from Liquid's raw {{ v.price }}
// with no `money` filter) come through as the value in the smallest
// currency subunit (paise for INR) -- e.g. "237800" for ₹2,378.00.
// Divide by 100 to get rupees.
//
// data-qty is the leading number parsed from the variant's own
// title (e.g. "30 Capsules" -> 30) -- drives the per-day figure.
//
// The Save amount is shown WITHOUT decimals ("Save ₹476" not
// "Save ₹476.00") to keep the pill compact and on one line, matching
// the server-rendered version (money_without_trailing_zeros in
// card-product.liquid).
document.addEventListener('change', function (e) {
  var select = e.target.closest('.packswitch__select');
  if (!select) return;

  var option = select.options[select.selectedIndex];
  var price = (parseFloat(option.getAttribute('data-price')) || 0) / 100;
  var compare = (parseFloat(option.getAttribute('data-compare')) || 0) / 100;
  var qty = parseFloat(option.getAttribute('data-qty')) || 0;
  var variantId = option.value;
  var available = option.getAttribute('data-available') === 'true';
  var optionLabel = option.getAttribute('data-label') || option.textContent.trim();

  var card = select.closest('.pcard');
  if (!card) return;

  function money(amount) {
    return '₹' + amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function moneyWhole(amount) {
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  }

  var valueEl = card.querySelector('.packswitch__value');
  var priceEl = card.querySelector('.pcard__price');
  var compareEl = card.querySelector('.pcard__compare');
  var discountInlineEl = card.querySelector('.pcard__discount-inline');
  var discountWrapEl = card.querySelector('.pcard__discount-wrap');
  var discountBadgeEl = card.querySelector('.pcard__discount');
  var saveEl = card.querySelector('.pcard__save');
  var perDayEl = card.querySelector('.pcard__perday');
  var variantInput = card.querySelector('.pcard__variant-input');
  var addBtn = card.querySelector('.pcard__addbtn');

  if (valueEl) valueEl.textContent = optionLabel;
  if (priceEl) priceEl.textContent = money(price);

  var hasDiscount = compare > price;
  var pct = hasDiscount ? Math.round(((compare - price) * 100) / compare) : 0;

  if (compareEl) {
    compareEl.textContent = hasDiscount ? money(compare) : '';
    compareEl.style.display = hasDiscount ? '' : 'none';
  }

  if (discountInlineEl) {
    discountInlineEl.textContent = hasDiscount ? pct + '% off' : '';
    discountInlineEl.style.display = hasDiscount ? 'inline' : 'none';
  }

  if (discountBadgeEl) discountBadgeEl.textContent = pct + '% OFF';
  if (discountWrapEl) discountWrapEl.style.display = hasDiscount ? '' : 'none';

  if (saveEl) {
    saveEl.textContent = hasDiscount ? 'Save ' + moneyWhole(compare - price) : '';
    saveEl.style.display = hasDiscount ? '' : 'none';
  }

  if (perDayEl) {
    if (qty > 1) {
      var perDay = Math.round(price / qty);
      perDayEl.textContent = 'JUST ' + money(perDay) + '/DAY';
      perDayEl.style.display = '';
    } else {
      perDayEl.style.display = 'none';
    }
  }

  if (variantInput) variantInput.value = variantId;

  if (addBtn && addBtn.tagName === 'BUTTON') {
    addBtn.disabled = !available;
    addBtn.textContent = available ? 'Add to cart' : 'Sold out';
  }
});
